import React from "react";
import { Grid, Paper } from "@material-ui/core";
import PropTypes from "prop-types";

import { useStyles } from "./styles";

export default function KooeeContainer(props) {
  const classes = useStyles();
  return (
    <Grid item className={props.rootClass && props.rootClass}>
      <Grid container className={classes.root} spacing={0}>
        <Grid item xs={12}>
          <Grid container justifyContent="center" spacing={0}>
            <Grid item>
              <Paper className={`${props.class ? props.class : classes.paper}`}>{props.content}</Paper>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

KooeeContainer.propTypes = {
  content: PropTypes.any,
  class: PropTypes.string,
  rootClass: PropTypes.string
};
